import $ from "cash-dom";
import axios from "axios";
import {formComponent} from "../form/component";

$(document).ready(() => {
    const $r = $('form');
    const form = $r.get(0);

    const $formGroups = {
        'request.name': $r.find('#form-group-request-name'),
        'request.component': $r.find('#form-group-request-component'),
        'request.investment': $r.find('#form-group-request-investment'),
        'request.challengeCode': $r.find('#form-group-request-code-challenge'),
        'request.contractNumber': $r.find('#form-group-request-contract-number'),
        'request.parentRequestIdentifier': $r.find('#form-group-request-parent-request-identifier'),
        'request.iban': $r.find('#form-group-request-iban'),
        'request.variableSymbol': $r.find('#form-group-request-variable-symbol'),
        'request.receiverBankName': $r.find('#form-group-request-receiver-bank-name'),
        'request.receiverAccountName': $r.find('#form-group-request-receiver-account-name'),
        'request.contractApprovedSum': $r.find('#form-group-request-contract-approved-sum'),
        'request.accepted': $r.find('#form-group-request-accepted'),

        '1A.firstName': $r.find('#form-group-1A-first-name'),
        '1A.lastName': $r.find('#form-group-1A-last-name'),
        '1A.titlePre': $r.find('#form-group-1A-title-pre'),
        '1A.titlePost': $r.find('#form-group-1A-title-post'),
        '1A.phone': $r.find('#form-group-1A-phone'),
        '1A.email': $r.find('#form-group-1A-email'),
        '1A.correspondenceAddress': $r.find('#form-group-1A-correspondence-address'),
        '1A.addressStreet': $r.find('#form-group-1A-address-street'),
        '1A.addressRegisterNumber': $r.find('#form-group-1A-address-register-number'),
        '1A.addressOrientationNumber': $r.find('#form-group-1A-address-orientation-number'),
        '1A.addressCity': $r.find('#form-group-1A-address-city'),
        '1A.addressPostalCode': $r.find('#form-group-1A-address-postal-code'),
        '1BC.contactPersonType': $r.find('#form-group-1BC-contact-person-type'),
    };

    const {
        inputEntries,
        inputs,
        setGeneralError,
        clearGeneralError,
        getValues,
        updateValue,
        setValue,
        validate,
        validateAll,
        watch,
    } = formComponent(
        $r, $formGroups,
        {
            getParser: ({text, checkBox, radio, date}) => ({
                'request.name': text,
                'request.component': text,
                'request.investment': text,
                'request.challengeCode': text,
                'request.contractNumber': text,
                'request.parentRequestIdentifier': text,
                'request.iban': text,
                'request.variableSymbol': text,
                'request.receiverBankName': text,
                'request.receiverAccountName': text,
                'request.contractApprovedSum': text,
                'request.accepted': text,

                '1A.firstName': text,
                '1A.lastName': text,
                '1A.titlePre': text,
                '1A.titlePost': text,
                '1A.phone': text,
                '1A.email': text,
                '1A.correspondenceAddress': text,
                '1A.addressStreet': text,
                '1A.addressRegisterNumber': text,
                '1A.addressOrientationNumber': text,
                '1A.addressCity': text,
                '1A.addressPostalCode': text,
                '1A.relationship': text,
                '1BC.contactPersonType': radio,
            }),
            getValidator: ({
                               any,
                               required,
                               cmp,
                               date,
                               email,
                               iban,
                               personalBirthNumber,
                               postalCode,
                               float2,
                               integer,
                               contractNumber3,
                               requestIdentifier,
                               min,
                               max,
                               and,
                               cond
                           }) => ({
                'request.name': required('Názov výzvy je povinný'),
                'request.component': required('Komponent je povinný'),
                'request.investment': required('Investícia je povinná'),
                'request.challengeCode': required('Kód výzvy je povinný'),
                'request.contractNumber': and(
                    required('Kód Projektu je povinný'),
                    contractNumber3('Kód Projektu musí byť vo formáte SPO-V03-ČČČČČ-Z (príklad: SPO-V03-00002-Z)'),
                ),
                'request.parentRequestIdentifier':  and(
                    required('Identifikátor ŽoPPM je povinný'),
                    requestIdentifier('Identifikátor ŽoPPM musí byť vo formáte ČČČČČČČČČČČČ'),
                ),
                'request.iban': and(
                    required('IBAN musí byť uvedený v správnom formáte a neobsahovať medzery'),
                    iban('IBAN je neplatný'),
                ),
                'request.variableSymbol': required('Variabilný symbol je povinný'),
                'request.receiverBankName': required('Názov banky je povinný'),
                'request.receiverAccountName': required('Názov účtu prijímateľa je povinný'),
                'request.contractApprovedSum': required('Schválená suma v EUR zo zmluvy je povinná'),
                'request.accepted': any,

                '1A.firstName': required('Krstné meno je povinné'),
                '1A.lastName': required('Priezvisko je povinné'),
                '1A.titlePre': any,
                '1A.titlePost': any,
                '1A.phone': required('Telefónne číslo je povinné'),
                '1A.email': and(
                    required('Email je povinný'),
                    email('Email musí mať správny formát'),
                ),
                '1A.correspondenceAddress': any,
                '1A.addressStreet': required('Ulica je povinná'),
                '1A.addressRegisterNumber': required('Súpisné číslo je povinné'),
                '1A.addressOrientationNumber': any,
                '1A.addressCity': required('Mesto je povinné'),
                '1A.addressPostalCode': postalCode('PSČ má nesprávny formát'),
                '1BC.contactPersonType': required('Typ kontaktnej osoby je povinný'),
            }),
            getInputEntries: ({findInputEntries, radio, date, select}) =>
                radio('1BC.contactPersonType', $formGroups,
                    findInputEntries($formGroups)
                ),
            getWatcher: () => ({
                'request.contractNumber': (value, self) => {
                    self.inputs['request.variableSymbol'].value = value.replace(/[^\d]+/g, '');
                    self.updateValue('request.variableSymbol');
                },
            }),
        }
    );

    const onInput = key => () => {
        updateValue(key);
        watch(key);
        validate(key);
        //console.log(getValues());
    };

    const onSubmit = async (e) => {
        e.preventDefault();

        clearGeneralError();
        if (!validateAll())
            return;

        try {
            const result = await axios.post('/api/platba-03/formular.php', getValues());
            //console.log(result.data);
            if (result.data && result.data.redirect)
                window.location.href = result.data.redirect;
            else
                alert('Operácia bola úspešná!');
        } catch (e) {
            if (e.response.data)
                setGeneralError(e.response.data);
            console.error(e);
        }
    };

    form.onsubmit = onSubmit;
    inputEntries.forEach(([key, input]) => input.oninput = onInput(key));
    const checkboxOnInput = key => inputs[key].forEach(input => input.oninput = onInput(key));
    const dateOnInput = key =>
        inputs[key].day.oninput = inputs[key].month.oninput = inputs[key].year.oninput = onInput(key);
    checkboxOnInput('1BC.contactPersonType');
});
